<template>
  <div class="system-permissions">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>权限管理</span>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleCreate">添加权限</el-button>
      </div>

      <el-table :data="list" border stripe v-loading="loading" style="width: 100%" row-key="id" default-expand-all :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="name" label="权限名称" min-width="160" />
        <el-table-column prop="slug" label="标识" width="180" />
        <el-table-column prop="path" label="路由路径" width="150" />
        <el-table-column label="类型" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 1 ? '' : 'info'" size="small">
              {{ scope.row.type === 1 ? '菜单' : '按钮' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="60" />
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #E4393C" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap" v-if="total > 0">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="query.limit"
          :current-page.sync="query.page"
          @current-change="getList"
        />
      </div>
    </el-card>

    <!-- 添加/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="520px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="父级权限">
          <el-select v-model="form.parent_id" placeholder="顶级权限" clearable style="width:100%">
            <el-option :value="0" label="顶级权限" />
            <el-option v-for="p in parentOptions" :key="p.id" :label="p.name" :value="p.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="权限名称" prop="name">
          <el-input v-model="form.name" placeholder="如：管理员管理" maxlength="50" />
        </el-form-item>
        <el-form-item label="权限标识" prop="slug">
          <el-input v-model="form.slug" placeholder="如：system.admins" maxlength="80" />
        </el-form-item>
        <el-form-item label="路由路径">
          <el-input v-model="form.path" placeholder="如：/system/admins" maxlength="100" />
        </el-form-item>
        <el-form-item label="前端组件">
          <el-input v-model="form.component" placeholder="如：System/Admins" maxlength="100" />
        </el-form-item>
        <el-form-item label="图标">
          <el-input v-model="form.icon" placeholder="如：el-icon-user" maxlength="50" />
        </el-form-item>
        <el-form-item label="类型">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">菜单</el-radio>
            <el-radio :label="2">按钮/操作</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :max="999" />
        </el-form-item>
        <el-form-item label="是否菜单">
          <el-radio-group v-model="form.is_menu">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRbacPermissions, createRbacPermission, updateRbacPermission, deleteRbacPermission } from '@/api'

export default {
  name: 'SystemPermissions',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      parentOptions: [],
      query: { page: 1, limit: 50 },
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      editId: null,
      submitLoading: false,
      form: {
        parent_id: 0,
        name: '',
        slug: '',
        path: '',
        component: '',
        icon: '',
        type: 1,
        sort: 0,
        is_menu: 1,
        status: 1
      },
      rules: {
        name: [{ required: true, message: '请输入权限名称', trigger: 'blur' }],
        slug: [{ required: true, message: '请输入权限标识', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      getRbacPermissions(this.query).then(res => {
        this.list = res.list || []
        this.total = res.total || 0
        // 构建父级选项
        this.parentOptions = (res.list || []).filter(p => p.type === 1)
      }).finally(() => { this.loading = false })
    },
    resetForm() {
      this.form = {
        parent_id: 0, name: '', slug: '', path: '', component: '',
        icon: '', type: 1, sort: 0, is_menu: 1, status: 1
      }
    },
    handleCreate() {
      this.isEdit = false
      this.editId = null
      this.dialogTitle = '添加权限'
      this.resetForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.dialogTitle = '编辑权限'
      this.form = {
        parent_id: row.parent_id || 0,
        name: row.name,
        slug: row.slug,
        path: row.path || '',
        component: row.component || '',
        icon: row.icon || '',
        type: row.type,
        sort: row.sort,
        is_menu: row.is_menu,
        status: row.status
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const apiCall = this.isEdit
          ? updateRbacPermission(this.editId, this.form)
          : createRbacPermission(this.form)

        apiCall.then(() => {
          this.$message.success(this.isEdit ? '更新成功' : '创建成功')
          this.dialogVisible = false
          this.getList()
        }).finally(() => { this.submitLoading = false })
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除权限 "${row.name}"？子权限将变为顶级权限。`, '提示', { type: 'warning' }).then(() => {
        deleteRbacPermission(row.id).then(() => {
          this.$message.success('删除成功')
          this.getList()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pagination-wrap {
  margin-top: 16px;
  text-align: right;
}
</style>
